export default {
  feedback: {
    success: 'App móvil guardada correctamente',
    error: 'Error al guardar la app móvil',
  },
};
